<template>
  <div class="overlay-thumbnail-drawer" :id="drawerId">
    <overlay-thumbnail
      v-for="image in images"
      :key="image.imgKey"
      :image="image"
      :colorSettingOptions="colorSettingOptions"
      :colorSettings="colorSettings"
      :selectedImage="selectedImage"
      :size="size"
      @selectRecord="$emit('selectRecord', {image, settings: $event})"/>
  </div>
</template>

<script>
import overlayThumbnail from "./OverlayThumbnail";
export default {
  name: "overlayImageDrawer",
  components: {overlayThumbnail},
  props: {
   images: Array,
   size: Object,
   colorSettingOptions: Array,
   colorSettings: Object,
   selectedImage: Object,
   drawerId: { type: String, default: "overlay-thumbnail-drawer" }
  }
}
</script>